module.exports = __webpack_public_path__ + "01_veryshort_gray.67b52c7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_veryshort_gray.png
// module id = KJNo
// module chunks = 0